import { render, staticRenderFns } from "./UploadFileIcon.vue?vue&type=template&id=3b15110a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b15110a')) {
      api.createRecord('3b15110a', component.options)
    } else {
      api.reload('3b15110a', component.options)
    }
    module.hot.accept("./UploadFileIcon.vue?vue&type=template&id=3b15110a", function () {
      api.rerender('3b15110a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/UploadFileIcon.vue"
export default component.exports